// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch } from '@store/hooks';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { inventoryCreateAccount } from '@store/INV/Transactions/InvIssue/invSlice';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import { useState } from 'react';
// import { Card } from '@components/card/card';

// interface Props {
//   selectedTransactions: any[];
//   onclose: (ev: any) => void;
// }

// const AddCreateAccountInventory = ({ selectedTransactions, onclose }: Props) => {
//   const { t, i18n } = useTranslation();
//   const [responseData, setResponseData] = useState<any[]>([]);
//   const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
//   const [showResults, setShowResults] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const dispatch = useAppDispatch();

//   const formik = useFormik({
//     initialValues: {},
//     onSubmit: async () => {
//       const ids = selectedTransactions?.map(m => m.id);

//       const body = {
//         transections: ids
//       };

//       const confirm = await confirmAction(t('confirmPostMessage'));

//       if (!confirm) {
//         formik.setSubmitting(false);
//         return;
//       }
//       setIsSubmitting(true);

//       dispatch(inventoryCreateAccount(body))
//         .unwrap()
//         .then(res => {
//           if (res.succeeded) {
//             setResponseData(res.data || []);
//             setShowResults(true);

//             // حساب الإحصائيات بعد استلام البيانات
//             const successCount = res.data.filter((item: any) => item.succeeded).length;
//             const errorCount = res.data.filter((item: any) => !item.succeeded).length;

//             // عرض رسالة تنبيه مناسبة بناءً على النتائج
//             if (errorCount === 0) {
//               // كل العمليات ناجحة
//               CustomAlert({
//                 action: 'Add',
//                 msg: t('PostSuccessMessage'),
//                 Timer: 10000
//               });
//             } else if (successCount === 0) {
//               // كل العمليات فاشلة
//               CustomAlert({
//                 action: 'Error',
//                 msg: t('AllOperationsFailed'),
//                 Timer: 10000
//               });
//             } else {
//               // بعض العمليات ناجحة والبعض الآخر فاشل
//               CustomAlert({
//                 action: 'Error',
//                 msg: `${successCount} ${t('operationsSucceeded')} ${errorCount} ${t('operationsFailed')}`,
//                 Timer: 10000
//               });
//             }

//             // التمرير تلقائياً إلى قسم النتائج
//             setTimeout(() => {
//               const resultsSection = document.getElementById('processing-results');
//               if (resultsSection) {
//                 resultsSection.scrollIntoView({ behavior: 'smooth' });
//               }
//             }, 300);
//           } else {
//             CustomAlert({
//               action: 'Error',
//               msg: res.message || t('PostErrorMessage')
//             });
//           }
//         })
//         .catch(error => {
//           console.error('Post error:', error);
//           CustomAlert({
//             action: 'Error',
//             msg: error.message || t('PostErrorMessage')
//           });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//           setIsSubmitting(false);
//         });
//     }
//   });
//   // حساب الإحصائيات
//   const successCount = responseData.filter(item => item.succeeded).length;
//   const errorCount = responseData.filter(item => !item.succeeded).length;
//   const totalCount = responseData.length;

//   return (
//     <div className='p-0'>
//       <div className='d-flex justify-content-between align-items-center mb-3'>
//         <h4 className='m-0 text-theme'>{t('PostInventory')}</h4>
//         <button
//           type='button'
//           className='btn-close'
//           onClick={onclose}
//           aria-label={t('Close')}
//           disabled={formik.isSubmitting}
//         ></button>
//       </div>

//       {/* ملخص العمليات المحددة */}
//       <div className='alert alert-info d-flex align-items-center'>
//         <i className='fas fa-info-circle me-2 fs-5'></i>
//         <div className='d-flex align-items-center justify-content-between w-100'>
//           <span>{t('selectedTransactionsCount')}</span>
//           <span className='fw-bold fs-5 badge bg-info text-dark'>{selectedTransactions?.length || 0}</span>
//         </div>
//       </div>

//       {/* جدول العمليات المحددة مع تمييز الصفوف */}
//       <div className='table-responsive mb-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
//         <table className='table table-sm table-bordered table-hover'>
//           <thead className='bg-body-secondary sticky-top'>
//             <tr>
//               <th className='pt-2 pb-2'>{t('نوع الحركة')}</th>
//               <th className='pt-2 pb-2'>{t('كود الحركة')}</th>
//               <th className='pt-2 pb-2'>{t('الحالة')}</th>
//             </tr>
//           </thead>
//           <tbody>
//             {selectedTransactions?.map((item, index) => (
//               <tr key={item.id} className={index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}>
//                 <td className='align-middle'>{item.transactionTypeName}</td>
//                 <td className='align-middle fw-bold'>{item.code}</td>
//                 <td className='align-middle'>
//                   <span className='badge bg-warning text-dark'>
//                     <i className='fas fa-clock me-1'></i>
//                     {t('Pending')}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         {(!selectedTransactions || selectedTransactions.length === 0) && (
//           <div className='text-center py-4 text-muted'>
//             <i className='fas fa-inbox fa-2x mb-2'></i>
//             <p>{t('NoTransactionsSelected')}</p>
//           </div>
//         )}
//       </div>

//       {/* نتائج المعالجة */}
//       {showResults && responseData.length > 0 && (
//         <div id='processing-results' className='mt-4'>
//           <div className='d-flex justify-content-between align-items-center mb-3'>
//             <h5 className='text-theme m-0'>
//               <i className='fas fa-list-check me-2'></i>
//               {t('ProcessingResults')}
//             </h5>

//             {/* أزرار التبويب */}
//             <div className='btn-group' role='group'>
//               <button
//                 type='button'
//                 className={`btn btn-sm ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
//                 onClick={() => setActiveTab('summary')}
//               >
//                 <i className='fas fa-chart-pie me-1'></i>
//                 {t('Summary')}
//               </button>
//               <button
//                 type='button'
//                 className={`btn btn-sm ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
//                 onClick={() => setActiveTab('details')}
//               >
//                 <i className='fas fa-table-list me-1'></i>
//                 {t('Details')}
//               </button>
//             </div>
//           </div>

//           {/* ملخص النتائج */}
//           {activeTab === 'summary' && (
//             <div className='row mb-4'>
//               <div className='col-md-4'>
//                 <Card className=' bg-body-secondary'>
//                   <div className='card-body text-center'>
//                     <h3 className='card-title'>{totalCount}</h3>
//                     <p className='card-text'>{t('TotalTransactions')}</p>
//                   </div>
//                 </Card>
//               </div>
//               <div className='col-md-4'>
//                 <Card className=' bg-success bg-opacity-30 '>
//                   <div className='card-body text-center'>
//                     <h3 className='card-title text-success'>{successCount}</h3>
//                     <p className='card-text'>{t('Successful')}</p>
//                   </div>
//                 </Card>
//               </div>
//               <div className='col-md-4'>
//                 <Card className=' bg-danger bg-opacity-30 '>
//                   <div className='card-body text-center'>
//                     <h3 className='card-title text-danger'>{errorCount}</h3>
//                     <p className='card-text'>{t('Failed')}</p>
//                   </div>
//                 </Card>
//               </div>
//             </div>
//           )}

//           {/* تفاصيل النتائج */}
//           {activeTab === 'details' && (
//             <div className='table-responsive' style={{ maxHeight: '400px', overflowY: 'auto' }}>
//               <table className='table table-sm table-bordered table-hover'>
//                 <thead className='  sticky-top'>
//                   <tr>
//                     <th className='pt-2 pb-2'>{t('code')}</th>
//                     <th className='pt-2 pb-2'>{t('type')}</th>
//                     <th className='pt-2 pb-2'>{t('status')}</th>
//                     <th className='pt-2 pb-2'>{t('errorMessage')}</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {responseData.map((item, index) => (
//                     <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
//                       <td className='align-middle fw-bold'>{item.code}</td>
//                       <td className='align-middle'>{i18n.language === 'en' ? item.type : item.type2}</td>
//                       <td className='align-middle'>
//                         {item.succeeded ? (
//                           <span className='badge bg-success'>
//                             <i className='fas fa-check-circle me-1'></i>
//                             {t('Success')}
//                           </span>
//                         ) : (
//                           <span className='badge bg-danger'>
//                             <i className='fas fa-exclamation-circle me-1'></i>
//                             {t('Failed')}
//                           </span>
//                         )}
//                       </td>

//                       <td className='align-middle'>
//                         {item.succeeded ? (
//                           <div className='text-success small d-flex align-items-center'>
//                             <i className='fas fa-check-circle me-1'></i>
//                             {t('Successful')}
//                           </div>
//                         ) : (
//                           <div className='text-danger small d-flex align-items-center'>
//                             <i className='fas fa-exclamation-triangle me-1'></i>
//                             {item.errorMessage || t('OperationFailed')}
//                           </div>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       )}

//       {/* أزرار الإجراء */}
//       <form onSubmit={formik.handleSubmit} className='mt-4'>
//         <div className='row g-2'>
//           <div className='col-md-6'>
//             <button
//               type='submit'
//               className='btn btn-lg btn-theme w-100 rounded-1 d-flex align-items-center justify-content-center'
//               disabled={formik.isSubmitting || isSubmitting || selectedTransactions?.length === 0}
//             >
//               {formik.isSubmitting || isSubmitting ? (
//                 <>
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                   {t('Processing')}
//                 </>
//               ) : (
//                 <>
//                   <i className='fas fa-paper-plane me-2'></i>
//                   {t('Post')} {selectedTransactions?.length > 0 && `(${selectedTransactions.length})`}
//                 </>
//               )}
//             </button>
//           </div>
//           <div className='col-md-6'>
//             <button
//               type='button'
//               className='btn btn-lg btn-outline-secondary w-100 rounded-1 d-flex align-items-center justify-content-center'
//               onClick={onclose}
//               disabled={formik.isSubmitting || isSubmitting}
//             >
//               <i className='fas fa-times me-2'></i>
//               {t('Cancel')}
//             </button>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };
// export default AddCreateAccountInventory;


import { useFormik } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@store/hooks';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import confirmAction from '@components/Shared/Alert/confirmAction';

import { Card, CardBody, CardHeader, CardFooter } from '@components/card/card';
import NeatixModal from '@components/Modal/NeatixModal';

import { inventoryCreateAccount } from '@store/INV/Transactions/InvIssue/invSlice';

// ✅ اختياري: عرض القيد (احذف هذا الاستيراد لو ما تبغاه)
import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';

interface Props {
  selectedTransactions: any[];
  onclose: (ev: any) => void;
}

const AddCreateAccountInventory = ({ selectedTransactions, onclose }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [responseData, setResponseData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
  const [showResults, setShowResults] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAllDetails, setShowAllDetails] = useState(false);

  // ✅ Journal Modal State (اختياري)
  const [showJournalModal, setShowJournalModal] = useState(false);
  const [journalRefId, setJournalRefId] = useState<string | null>(null);

  // ✅ Auto-scroll to results
  useEffect(() => {
    if (showResults) {
      setTimeout(() => {
        const el = document.getElementById('processing-results');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [showResults]);

  // ✅ resolve referenceId لعرض القيد (اختياري)
  const resolveReferenceId = (resultItem: any) => {
    // لو API يرجع referenceId مباشرة
    const direct =
      resultItem?.referenceId ??
      resultItem?.refId ??
      resultItem?.transactionId ??
      resultItem?.transectionId ??
      resultItem?.id;

    if (direct) return String(direct);

    // fallback: نطابق حسب code مع المحدد ونستخدم id حق الحركة
    const matched = selectedTransactions?.find(x => String(x.code) === String(resultItem?.code));
    return matched?.id ? String(matched.id) : null;
  };

  const openJournal = (refId: string | null) => {
    if (!refId) return;
    setJournalRefId(refId);
    setShowJournalModal(true);
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async () => {
      const ids = (selectedTransactions || []).map(m => m.id);
      const body = { transections: ids };

      const confirm = await confirmAction(t('confirmPostMessage'));
      if (!confirm) return;

      setIsSubmitting(true);
      setShowResults(false);
      setResponseData([]);
      setShowAllDetails(false);

      dispatch(inventoryCreateAccount(body))
        .unwrap()
        .then(res => {
          if (!res?.succeeded) {
            CustomAlert({
              action: 'Error',
              msg: res?.message || t('PostErrorMessage'),
              Timer: 10000
            });
            return;
          }

          const data = res?.data || [];
          setResponseData(data);
          setShowResults(true);

          const successCount = data.filter((x: any) => x.succeeded).length;
          const errorCount = data.filter((x: any) => !x.succeeded).length;
          const totalCount = data.length;

          if (errorCount === 0) {
            CustomAlert({ action: 'Add', msg: t('PostSuccessMessage'), Timer: 5000 });
          } else if (successCount === 0) {
            CustomAlert({ action: 'Error', msg: t('AllOperationsFailed'), Timer: 10000 });
          } else {
            CustomAlert({
              action: 'Error',
              msg: `${successCount}/${totalCount} ${t('operationsSucceeded')}`,
              Timer: 8000
            });
          }
        })
        .catch((error: any) => {
          console.error('Post error:', error);
          CustomAlert({
            action: 'Error',
            msg: error?.message || t('PostErrorMessage'),
            Timer: 10000
          });
        })
        .finally(() => {
          formik.setSubmitting(false);
          setIsSubmitting(false);
        });
    }
  });

  // ✅ إحصائيات النتائج
  const successCount = responseData.filter(x => x.succeeded).length;
  const errorCount = responseData.filter(x => !x.succeeded).length;
  const totalCount = responseData.length;

  // ✅ Map النتائج حسب code لتلوين حالة كل حركة في جدول المحدد
  const resultByCode = useMemo(() => {
    const map = new Map<string, any>();
    responseData.forEach(r => {
      if (r?.code != null) map.set(String(r.code), r);
    });
    return map;
  }, [responseData]);

  const getStatusBadgeForSelected = (trx: any) => {
    if (!showResults) {
      return (
        <span className='badge bg-warning bg-opacity-20 text-warning border border-warning border-opacity-50'>
          <i className='fas fa-clock me-1'></i>
          {t('Pending')}
        </span>
      );
    }

    const r = resultByCode.get(String(trx.code));
    if (!r) {
      return (
        <span className='badge bg-secondary bg-opacity-20 text-secondary'>
          <i className='fas fa-question-circle me-1'></i>
          {t('Unknown')}
        </span>
      );
    }

    return r.succeeded ? (
      <span className='badge bg-success bg-opacity-20 text-success border border-success border-opacity-50'>
        <i className='fas fa-check-circle me-1'></i>
        {t('Success')}
      </span>
    ) : (
      <span className='badge bg-danger bg-opacity-20 text-danger border border-danger border-opacity-50'>
        <i className='fas fa-exclamation-circle me-1'></i>
        {t('Failed')}
      </span>
    );
  };

  const displayedDetails = showAllDetails ? responseData : responseData.slice(0, 5);

  const safeDate = (dt?: string) => (dt ? String(dt).split('T')[0] : '—');

  const getTypeText = (item: any) => {
    // نتائج API غالباً type/type2
    if (item?.type != null || item?.type2 != null) {
      return i18n.language === 'en' ? item.type : item.type2 || item.type;
    }

    // المحدد غالباً transactionTypeName/transactionTypeName2
    return i18n.language === 'en'
      ? item.transactionTypeName
      : item.transactionTypeName2 || item.transactionTypeName;
  };

  return (
    <>
      <div className='p-0'>
        {/* رأس */}
        <div className='d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom'>
          <div>
            <h4 className='m-0 text-theme fw-bold'>
              <i className='fas fa-warehouse me-2'></i>
              {t('PostInventory') || 'ترحيل العمليات المخزنية'}
            </h4>
          </div>

          <button
            type='button'
            className='btn btn-outline-secondary btn-sm'
            onClick={() => onclose(null)}
            disabled={formik.isSubmitting || isSubmitting}
          >
            <i className='fas fa-times me-1'></i>
            {t('Close')}
          </button>
        </div>

        {/* بطاقة العدد */}
        <div className='mb-4'>
          <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
            <CardBody className='d-flex align-items-center p-3'>
              <i className='fas fa-boxes fa-2x text-primary me-3'></i>
              <div className='flex-grow-1'>
                <h4 className='text-primary mb-0'>{selectedTransactions?.length || 0} حركة</h4>
                <p className='text-muted mb-0 small'>محددة للترحيل</p>
              </div>
              <span className='badge bg-success fs-6'>
                <i className='fas fa-check-circle me-1'></i>
                جاهزة
              </span>
            </CardBody>
          </Card>
        </div>

        {/* جدول المحدد */}
        <Card className='mb-4 border-0 shadow-sm'>
          <CardHeader className='d-flex justify-content-between align-items-center bg-transparent border-0'>
            <h5 className='mb-0'>
              <i className='fas fa-list-check me-2 text-theme'></i>
              الحركات المحددة
              <span className='badge bg-primary ms-2'>{selectedTransactions?.length || 0}</span>
            </h5>

            <span className='badge bg-theme'>إجمالي المحدد: {selectedTransactions?.length || 0}</span>
          </CardHeader>

          <CardBody className='p-0'>
            <div className='table-responsive' style={{ maxHeight: '300px' }}>
              <table className='table table-hover mb-0'>
                <thead
                  className='table-active fw-bold'
                  style={{ position: 'sticky', top: 0, zIndex: 101, backdropFilter: 'blur(30px)' }}
                >
                  <tr>
                    <th className='text-center small'>كود الحركة</th>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>نوع الحركة</th>
                    <th className='text-center small'>وحدة التشغيل / المخزن</th>
                    <th className='text-center small'>الحالة</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedTransactions?.map((item: any) => {
                    const branchName =
                      i18n.language === 'en' ? item.branchName : item.branchName2 || item.branchName;
                    const invName =
                      i18n.language === 'en' ? item.inventory : item.inventory2 || item.inventory;

                    return (
                      <tr key={item.id}>
                        <td className='text-center align-middle'>
                          <strong className='text-theme'>{item.code}</strong>
                        </td>

                        <td className='text-center align-middle'>
                          <strong>{safeDate(item.transactionDate)}</strong>
                        </td>

                        <td className='text-center align-middle'>
                          <span className='badge bg-info'>{getTypeText(item)}</span>
                        </td>

                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <small className='fw-bold'>
                              <i className='fas fa-building me-1'></i>
                              {branchName || '—'}
                            </small>
                            <small className='text-muted'>
                              <i className='fas fa-warehouse me-1'></i>
                              {invName || '—'}
                            </small>
                          </div>
                        </td>

                        <td className='text-center align-middle'>{getStatusBadgeForSelected(item)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {(!selectedTransactions || selectedTransactions.length === 0) && (
                <div className='text-center py-4 text-muted'>
                  <i className='fa fa-inbox fa-2x mb-2'></i>
                  <br />
                  {t('NoTransactionsSelected')}
                </div>
              )}
            </div>
          </CardBody>

          <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
            <div className='text-muted small'>
              عرض {selectedTransactions?.length || 0} من {selectedTransactions?.length || 0} حركة
            </div>
            <div className='text-theme fw-bold'>
              <i className='fas fa-info-circle me-1'></i>
              جاهزة للمعالجة
            </div>
          </CardFooter>
        </Card>

        {/* نتائج المعالجة */}
        {showResults && responseData.length > 0 && (
          <div id='processing-results' className='mt-4'>
            <Card className='border-0 shadow-sm'>
              <CardHeader className='bg-transparent border-0'>
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <h5 className='m-0 text-theme'>
                      <i className='fas fa-chart-bar me-2'></i>
                      {t('ProcessingResults')}
                    </h5>
                  </div>

                  <div className='btn-group btn-group-sm' role='group'>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('summary')}
                    >
                      <i className='fas fa-chart-pie me-1'></i>
                      {t('Summary')}
                    </button>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('details')}
                    >
                      <i className='fas fa-list me-1'></i>
                      {t('Details')}
                    </button>
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                {activeTab === 'summary' ? (
                  <div className='row mb-2'>
                    <div className='col-md-4'>
                      <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
                        <CardBody className='text-center py-4'>
                          <i className='fas fa-cogs fa-2x text-primary mb-3'></i>
                          <h3 className='text-primary mb-1'>{totalCount}</h3>
                          <p className='text-muted mb-0'>إجمالي المعالجة</p>
                        </CardBody>
                      </Card>
                    </div>

                    <div className='col-md-4'>
                      <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm'>
                        <CardBody className='text-center py-4'>
                          <i className='fas fa-check-circle fa-2x text-success mb-3'></i>
                          <h3 className='text-success mb-1'>{successCount}</h3>
                          <p className='text-muted mb-0'>عمليات ناجحة</p>
                        </CardBody>
                      </Card>
                    </div>

                    <div className='col-md-4'>
                      <Card className='bg-danger bg-opacity-10 border-danger border-0 shadow-sm'>
                        <CardBody className='text-center py-4'>
                          <i className='fas fa-times-circle fa-2x text-danger mb-3'></i>
                          <h3 className='text-danger mb-1'>{errorCount}</h3>
                          <p className='text-muted mb-0'>عمليات فاشلة</p>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                ) : (
                  <div className='table-responsive' style={{ maxHeight: '400px' }}>
                    <table className='table table-hover mb-0'>
                      <thead className='table-active fw-bold'>
                        <tr>
                          <th className='text-center small'>الكود</th>
                          <th className='text-center small'>النوع</th>
                          <th className='text-center small'>الحالة</th>
                          <th className='text-center small'>التفاصيل</th>
                          <th className='text-center small'>الإجراءات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedDetails.map((item: any, idx: number) => {
                          const refId = resolveReferenceId(item);
                          const typeText = getTypeText(item);

                          return (
                            <tr key={idx} className={item.succeeded ? 'table-success' : 'table-danger'}>
                              <td className='text-center align-middle'>
                                <strong>{item.code}</strong>
                              </td>

                              <td className='text-center align-middle'>
                                <span className='badge bg-info'>{typeText}</span>
                              </td>

                              <td className='text-center align-middle'>
                                {item.succeeded ? (
                                  <span className='badge bg-success'>
                                    <i className='fas fa-check-circle me-1'></i>
                                    {t('Success')}
                                  </span>
                                ) : (
                                  <span className='badge bg-danger'>
                                    <i className='fas fa-exclamation-circle me-1'></i>
                                    {t('Failed')}
                                  </span>
                                )}
                              </td>

                              <td className='align-middle'>
                                <div className={`small ${item.succeeded ? 'text-success' : 'text-danger'}`}>
                                  <i
                                    className={`fas fa-${
                                      item.succeeded ? 'check-circle' : 'exclamation-triangle'
                                    } me-1`}
                                  ></i>
                                  {item.succeeded ? t('Successful') : item.errorMessage || t('OperationFailed')}
                                </div>
                              </td>

                              <td className='text-center align-middle'>
                                {/* ✅ اختياري: عرض القيد */}
                                {item.succeeded && refId ? (
                                  <button
                                    type='button'
                                    className='btn btn-sm btn-outline-primary'
                                    onClick={() => openJournal(refId)}
                                    title={t('ViewJournalEntry')}
                                  >
                                    <i className='fas fa-eye me-1'></i>
                                    {t('عرض القيد')}
                                  </button>
                                ) : (
                                  <span className='text-muted small'>-</span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    {responseData.length > 5 && (
                      <div className='text-center py-3 border-top'>
                        <button
                          type='button'
                          className='btn btn-link text-decoration-none'
                          onClick={() => setShowAllDetails(!showAllDetails)}
                        >
                          <i className={`fas fa-chevron-${showAllDetails ? 'up' : 'down'} me-1`}></i>
                          {showAllDetails ? t('ShowLess') : t('ShowAllResults', { count: responseData.length })}
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </CardBody>

              {activeTab === 'details' && (
                <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
                  <div className='text-muted small'>
                    عرض {displayedDetails.length} من {responseData.length} نتيجة
                  </div>
                  <div className='text-theme fw-bold'>
                    ناجحة: {successCount} | فاشلة: {errorCount}
                  </div>
                </CardFooter>
              )}
            </Card>
          </div>
        )}

        {/* أزرار الإجراء */}
        <form onSubmit={formik.handleSubmit} className='mt-4'>
          <div className='row g-3'>
            <div className='col-md-6'>
              <button
                type='submit'
                className='btn btn-theme w-100 py-3 d-flex align-items-center justify-content-center'
                disabled={formik.isSubmitting || isSubmitting || selectedTransactions?.length === 0}
              >
                {formik.isSubmitting || isSubmitting ? (
                  <>
                    <div className='spinner-border spinner-border-sm me-2'></div>
                    {t('Processing')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-paper-plane me-2'></i>
                    <div className='d-flex flex-column align-items-start'>
                      <span className='fw-bold'>{t('Post')}</span>
                    </div>
                  </>
                )}
              </button>
            </div>

            <div className='col-md-6'>
              <button
                type='button'
                className='btn btn-outline-secondary w-100 py-3 d-flex align-items-center justify-content-center'
                onClick={() => onclose(null)}
                disabled={formik.isSubmitting || isSubmitting}
              >
                <i className='fas fa-times me-2'></i>
                <span className='fw-bold'>{t('Cancel')}</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* ✅ Modal عرض القيد (اختياري) */}
      <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' showHeader={false}>
        <div className='p-3'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div>
              <h5 className='m-0 text-theme'>
                <i className='fas fa-book me-2'></i>
                {t('عرض القيد')}
              </h5>
            </div>

            <button type='button' className='btn btn-outline-secondary btn-sm' onClick={() => setShowJournalModal(false)}>
              <i className='fas fa-times me-1'></i>
              {t('Close')}
            </button>
          </div>

          {journalRefId && <JournalsByReference referenceId={journalRefId} />}
        </div>
      </NeatixModal>
    </>
  );
};

export default AddCreateAccountInventory;
